import React from 'react'
import MainLayout from '../layouts/MainLayout'

const LocationErrorPage = () => {
  return (
    <MainLayout>
      <div className='w-full py-16 text-center text-white'>
        <h1 className='text-7xl my-8 text-yellow-300'>Currently Data Is Not Available Due To Technical Issue</h1>
        <h2 className='text-xl'>Reload the page or Login again and try to access this Page</h2>
      </div>
    </MainLayout>
  )
}

export default LocationErrorPage